import { Link } from 'react-router-dom';
import { site } from '../content/site';

export function Footer() {
  return (
    <footer className="mt-auto bg-mint-800 text-mint-100">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6 py-12 text-center sm:px-8">
        <img
          src="/images/signature.png"
          alt=""
          width={1340}
          height={523}
          className="h-12 w-auto opacity-90 brightness-0 invert"
        />

        <p className="max-w-md text-sm leading-relaxed text-mint-100/80">
          {site.role} in {site.location}. Nannying and babysitting for infants through age five.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 font-display text-sm font-semibold">
          <Link to="/resume" className="transition-colors hover:text-white">
            Resumé
          </Link>
          <Link to="/contact" className="transition-colors hover:text-white">
            Contact
          </Link>
          <a href={`mailto:${site.email}`} className="transition-colors hover:text-white">
            {site.email}
          </a>
        </div>

        <p className="text-xs text-mint-100/60">
          &copy; {new Date().getFullYear()} {site.legalName}
        </p>
      </div>
    </footer>
  );
}
